import * as React from "react";
import { InactiveIngredientAdminModel, InactiveIngredientFilterSettingsModel, InactiveIngredientGridModel, InactiveIngredientForGridModel }
  from "../../../models/inactiveIngredient";
import InactiveIngredientList from './inactiveIngredientList';
import InactiveIngredientService from '../../../services/inactiveIngredientService';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import Loadable from 'react-loadable';
import { InactiveIngredientFilter } from './inactiveIngredientFilter';
import InactiveIngredientAddEditDialog from './inactiveIngredientAddEditDialog';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { Lang } from '../../../common/enums';
import { InactiveIngredientContentModel } from '../../../models/inactiveIngredient/inactiveIngredientContentModel';

/*const MedicineAddEditLoadable = Loadable({
	loader: () => import('./activeIngredientsAddEditDialog'),
	loading: Spinner,
	delay: 1000, // 0.1 seconds
	timeout: 10000, // 10 seconds
});*/

interface IProps {
}

interface IState {
  inactiveIngredients: Array<InactiveIngredientForGridModel>;
  isLoading: boolean;
  error: any;
  validationMessage: string;
  isVisibleDialog: boolean;
  isVisibleDialogWrap: boolean;
  isVisibleConfirmDialog: boolean;
  currentInactiveIngredient: InactiveIngredientAdminModel;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  inactiveIngredientSettings: InactiveIngredientFilterSettingsModel
}

const initFrom = 0;
const numberOfRows = 10;

class InactiveIngredientContainer extends React.Component<IProps, IState> {
  inactiveIngredientService = new InactiveIngredientService();
  messages: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      inactiveIngredients: new Array<InactiveIngredientForGridModel>(0),
      isLoading: false,
      isVisibleDialog: false,
      isVisibleDialogWrap: false,
      isVisibleConfirmDialog: false,
      currentInactiveIngredient: new InactiveIngredientAdminModel(),
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      inactiveIngredientSettings: new InactiveIngredientFilterSettingsModel()
    };
  }

  // events
  componentDidMount() {
    this.getAllInactiveIngredients(this.state.from, this.state.numberOfRows);
  }

  // handles
  handleAddAndEditClick = id => {
    if (!id) { // Add			
      let inactiveIngredient = new InactiveIngredientAdminModel();
      let contentList = new Array<InactiveIngredientContentModel>(0);
      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new InactiveIngredientContentModel();
        content.langId = parseInt(Lang[k]);
        content.name = '';
        contentList.push(content);
      });

      inactiveIngredient.inactiveIngredientContent = contentList;
      this.setcurrentInactiveIngredient(inactiveIngredient);
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true
      });
      this.inactiveIngredientService.getInactiveIngredient(id)
        .then(
          (data: InactiveIngredientAdminModel) => {
            this.setcurrentInactiveIngredient(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.setState({
              error,
              isLoading: false
            });
          }
        );
    }
  };

  getInactiveIngredient = (id) => {
    this.inactiveIngredientService.getInactiveIngredient(id)
      .then(
        (data: InactiveIngredientAdminModel) => {
          this.setcurrentInactiveIngredient(data);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleDeleteClick = (id) => {
    this.getInactiveIngredient(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteInactiveIngredient(id) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.inactiveIngredientService.deleteInactiveIngredient(id)
      .then(
        data => {
          this.getAllInactiveIngredients(this.state.from, this.state.numberOfRows);
          this.setState({
            isLoading: false
          });
        },
        error => {
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleSaveButton = (currentInactiveIngredient: InactiveIngredientAdminModel) => {
    this.setState({
      isLoading: true
    });

    if (!currentInactiveIngredient.inactiveIngredientId) { // Add
      this.inactiveIngredientService.addInactiveIngredient(currentInactiveIngredient)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentInactiveIngredient(new InactiveIngredientAdminModel());
            this.getAllInactiveIngredients(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentInactiveIngredient(new InactiveIngredientAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          }
        );
    } else { // Edit
      this.inactiveIngredientService.editInactiveIngredient(currentInactiveIngredient.inactiveIngredientId, currentInactiveIngredient)
        .then(
          (data) => {
            this.showEditDialog(false);
            this.setcurrentInactiveIngredient(new InactiveIngredientAdminModel());
            this.getAllInactiveIngredients(this.state.from, this.state.numberOfRows);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.showEditDialog(false);
            this.setcurrentInactiveIngredient(new InactiveIngredientAdminModel());
            this.setState({
              error
            });
            this.setState({
              isLoading: false
            });
          });
    }
  };

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  // methods
  getAllInactiveIngredients(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.inactiveIngredientService.getAllInactiveIngredients(from, numberOfRows, this.state.inactiveIngredientSettings).then(
      (data: InactiveIngredientGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          inactiveIngredients: data.inactiveIngredients,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  setcurrentInactiveIngredient(inactiveIngredient: InactiveIngredientAdminModel) {
    this.setState({ currentInactiveIngredient: { ...inactiveIngredient } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialogWrap: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleDialog: show
    }));
  };

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    this.getAllInactiveIngredients(startIndex, this.state.numberOfRows);
  }

  handleSearchButtonClick = (settings) => {
    this.setState({
      isLoading: true
    });

    this.inactiveIngredientService.getAllInactiveIngredients(initFrom, numberOfRows, settings).then(
      (data: InactiveIngredientGridModel) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          inactiveIngredients: data.inactiveIngredients,
          inactiveIngredientSettings: settings,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  // render
  public render() {

    const { inactiveIngredients, isLoading, error } = this.state;

    return (
      <div>

        <h3>Inactive Ingredients</h3>

        {isLoading ? <Spinner /> : null}

        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        {this.state.isVisibleDialogWrap ? (
          <InactiveIngredientAddEditDialog
            saveClick={this.handleSaveButton}
            cancelClick={this.handleCancelButton}
            currentInactiveIngredient={this.state.currentInactiveIngredient}
            isVisible={this.state.isVisibleDialog}
          />
        ) : null}

        <div className="mb-2">
          <button
            onClick={() => this.handleAddAndEditClick(null)}
            className="btn btn-success"
            style={{ marginRight: "5px" }}>
            Add New
                </button>
        </div>

        <InactiveIngredientFilter
          onSearchClick={this.handleSearchButtonClick}
          totalRecordsCount={this.state.totalRecordsCount}
        />

        <InactiveIngredientList
          inactiveIngredients={inactiveIngredients}
          rows={numberOfRows}
          totalRecords={this.state.totalRecordsCount}
          onPageClick={this.handleOnPageClick}
          first={this.state.from}
          loading={Spinner}
          editClick={this.handleAddAndEditClick}
          deleteClick={this.handleDeleteClick}
        />

        <ConfirmDialog
          headerTitle="Confirm Dialog"
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteInactiveIngredient(this.state.currentInactiveIngredient.inactiveIngredientId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          Are you sure that you want to delete "{this.state.currentInactiveIngredient.name}"?
        </ConfirmDialog>
      </div>
    );
  }
}

export default InactiveIngredientContainer;